import { animate, inView } from "motion";

document.addEventListener("DOMContentLoaded", () => {
    inView(
        ".content-cards",
        () => {
            document.querySelectorAll(".card").forEach((card, index) => {
                const offsetX = 30 + index * 10;
                const offsetY = 30 + index * 50;

                animate(
                    card,
                    {
                        opacity: [0, 1],
                        transform: [
                            `translate(${-offsetX}px, ${offsetY}px)`,
                            "translate(0px, 0px)",
                        ],
                    },
                    {
                        duration: 0.8,
                        easing: "ease-out",
                    }
                );
            });
        },
        {
            once: true,
            margin: "0px 0px -550px 0px",
        }
    );
});
